module.exports = __webpack_public_path__ + "static/media/social1.2422973b.svg";